import React from 'react'

import {
} from 'react-router-dom'

import EstimationManagement from './pages/secure/abstract/EstimationManagement'
import EstimationSheetTab from './pages/secure/EstimationEdit/EstimationSheetTab'
import LaborCostPrintTab from './print/LaborCostPrintTab'
import MaterialCostPrintTab from './print/MaterialCostPrintTab'
import LaborUnitPricePrintTab from './print/LaborUnitPricePrintTab'
import EstimationActions from './libs/EstimationActions'
import Loading from '../common/component/Loading'

class PrintApp extends EstimationManagement {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
    EstimationActions.setEditableMode(false)
  }
  componentWillMount () {
    const {params} = this.props.match
    const estimationId = params.estimationId
    this.loadEstimation(estimationId)
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    return (
      <div>
        <EstimationSheetTab isEditable={false}  isPrintable={true} />
        <div style={{width: '307mm', margin: '0 auto'}}>
          <LaborCostPrintTab isEditable={false} />
          <MaterialCostPrintTab isEditable={false} />
          <LaborUnitPricePrintTab isEditable={false} />
        </div>
      </div>
    )
  }
}

export default PrintApp



// WEBPACK FOOTER //
// ./src/company_user/PrintApp.js